import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=1b2084f2&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=ts&"
export * from "./Category.vue?vue&type=script&lang=ts&"
import style0 from "./Category.vue?vue&type=style&index=0&id=1b2084f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2084f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2084f2')) {
      api.createRecord('1b2084f2', component.options)
    } else {
      api.reload('1b2084f2', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=1b2084f2&scoped=true&", function () {
      api.rerender('1b2084f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Setup/Category.vue"
export default component.exports